<template>
    <div class="search-des">
        <v-select
            v-model="des"
            :items="items"
            item-text="label"
            item-value="value"
            append-icon="mdi-chevron-down"
            label="Degré élevé de solidarité"
            dense
            clearable
            outlined
            hide-details
            class="search-container rounded-0"
        />
    </div>
</template>

<script>
export default {
    props: ["value", "annotationOptions"],
    data() {
        return {
            des: null,
        };
    },
    mounted() {
        this.des = this.value;
    },
    computed: {
        items() {
            const dico = this.$privateDico.convention;
            return [
                { label: dico.des.withDes, value: "true" },
                { label: dico.des.withoutDes, value: "false" },
            ];
        },
    },
    watch: {
        async des(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.des = _value;
        },
    },
};
</script>

<style lang="sass" scoped>
.search-des
    margin: 8px
</style>
